import { ProficiencyLevel } from '@shared/types';
import { nextProficiency, PROFICIENCY_CYCLE } from '../lib/proficiency';

interface Props {
  value: ProficiencyLevel;
  onChange: (value: ProficiencyLevel) => void;
  // WHY: When the proficiency differs from the saved character, draw a ring in the
  // unsaved-changes highlight color so the change is obvious at a glance.
  highlight?: boolean;
}

export default function ProficiencyCircle({ value, onChange, highlight = false }: Props) {
  const cycle = () => {
    onChange(nextProficiency(value));
  };

  const containerClass =
    value === 'expertise'
      ? 'bg-dnd-accent border-dnd-accent'
      : value === 'proficient'
      ? 'border-dnd-accent'
      : 'border-gray-500';

  return (
    <button
      type="button"
      onClick={cycle}
      aria-label={`Proficiency: ${value}. Click to change.`}
      title={`Proficiency: ${value}`}
      // WHY: Reduced from 44px to 36px to save horizontal space in the skills row.
      className={`proficiency-circle relative flex shrink-0 items-center justify-center h-9 w-9 rounded-full border-2 transition-colors focus:outline-none focus:ring-2 focus:ring-dnd-accent ${containerClass}${highlight ? ' ring-2 ring-dnd-dirty' : ''}`}
    >
      {/* WHY: Inner dot at half the container size represents "proficient" (one step below full). */}
      {value === 'proficient' && (
        <span className="h-1/2 w-1/2 rounded-full bg-dnd-accent" />
      )}
    </button>
  );
}
